export const TIMELINE_ROW_TEXT = {
	autoClose: 'autoclose',
};
